const ProcessSteps = () => {
  const steps = [
    {
      number: '01',
      title: 'Site Assessment',
      description: 'We evaluate your project requirements, block specifications, and access conditions to plan the optimal filling approach.'
    },
    {
      number: '02',
      title: 'Equipment Setup',
      description: 'Our team positions specialized pumping equipment for efficient and precise concrete delivery to all block cavities.'
    },
    {
      number: '03',
      title: 'Professional Filling',
      description: 'Experienced operators carefully fill each block cavity, ensuring complete coverage and proper consolidation.'
    },
    {
      number: '04',
      title: 'Quality Verification',
      description: 'We inspect the completed work to verify all blocks are properly filled and meet structural specifications.'
    }
  ];

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Our Block Filling Process
          </h2>
          <p className="text-lg text-slate-600">
            A systematic approach that ensures quality results on every project, from start to finish.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-lg p-8 h-full">
                <div className="text-6xl font-bold text-amber-500/20 mb-4">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                  <i className="ri-arrow-right-line text-2xl text-amber-500"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;